import { FeedbackEditor } from "./FeedbackEditor";
import React, { useEffect, useState } from "react";
import { useApiClient } from "../../../api";
import { Card, CardContent } from "@mui/material";
import Typography from "@mui/material/Typography";

export const OverallFeedback = ({
  assignment = null,
  assignmentQuestion = null,
  onRefresh = null,
}) => {
  if (!assignment && !assignmentQuestion) {
    throw Error(
      "At least one of assignment or assignmentQuestion should be provided",
    );
  }
  if (assignment && assignmentQuestion) {
    throw Error(
      "Only one of assignment or assignmentQuestion should be provided",
    );
  }

  const ApiClient = useApiClient();
  const [feedback, setFeedback] = useState({});

  const updateFeedback = async ({ areasToImprove, specificFeedback }) => {
    try {
      const response = await ApiClient.assignment.updateOverallFeedback({
        assignmentQuestionFeedback: assignmentQuestion && feedback?.id,
        assignmentFeedback: assignment && feedback?.id,
        areasToImprove,
        specificFeedback,
      });
      if (response) {
        setFeedback(response.feedback);
      }
    } catch (error) {
      console.error("Failed to update Feedback", error);
    }
  };

  useEffect(() => {
    if (!assignment?.feedback?.id && !assignmentQuestion?.feedback?.id) return;
    const subscription = ApiClient.assignment.pollOverallFeedback({
      assignmentQuestionFeedback: assignmentQuestion?.feedback.id,
      assignmentFeedback: assignment?.feedback.id,
      pollInterval: 5000,
      onUpdate: (data) => {
        setFeedback(data);
      },
    });

    return () => subscription.unsubscribe();
  }, [assignment?.feedback?.id, assignmentQuestion?.feedback?.id]);

  if (!feedback || Object.keys(feedback).length === 0) {
    return (
      <Card sx={{ flex: 1, mt: 2 }}>
        <CardContent>
          <Typography>
            Summary feedback will be provided when more answers have been marked
          </Typography>
        </CardContent>
      </Card>
    );
  }
  return (
    <Card data-testid="overall-feedback-card" sx={{ flex: 1, mt: 2 }}>
      <CardContent>
        <FeedbackEditor
          canonicalEntityInsights={feedback.canonicalEntityInsights}
          allowGenerate={feedback.allowGenerate}
          savedFeedback={feedback}
          onSave={updateFeedback}
          assignmentQuestion={assignmentQuestion}
          assignment={assignment}
          onRefresh={onRefresh}
        />
      </CardContent>
    </Card>
  );
};
